
export interface ICustomerDTO {
  id?: number;
  dashId?: number;
  address?: string;
  category?: string;
  deadline?: any;
  city?: string;
  codeTarafHesab?: string;
  deleted?: string;
  description?: string;
  otherFeatures?: string;
  postalCode?: string;
  country?: string;
  jalaliDate?: any;
  state?: string;
  theMethodIntroduction?: string;
  title?: string;
  nationalId?: string;
  economicCode?: string;
  website?: string;
  type?: string;
  officeWork?: string;
  fieldActivity?: string;
  methodIntroduction?: string;
  status?: string;
  // phones?: IPhone[];
  // orderObjects?: IOrderObject[];
  // transactions?: ITransaction[];
  // customerFiles?: ICustomerFile[];
  // projects?: IProject[];
  users?: any;
  usersId?: any;
  usersList?: any[];
}

export class CustomerDTO implements ICustomerDTO {
  constructor(public id?: number,
              public address?: string,
              public category?: string,
              public city?: string,
              public codeTarafHesab?: string,
              public deleted?: string,
              public deadline?: any,
             public jalaliDate?: any,
              public description?: string,
              public otherFeatures?: string,
              public postalCode?: string,
              public country?: string,
              public state?: string,
              public theMethodIntroduction?: string,
              public title?: string,
              public website?: string,
              public type?: string,
              public officeWork?: string,
              public fieldActivity?: string,
              public methodIntroduction?: string,
              public status?: string,
              // public phones?: IPhone[],
              // public orderObjects?: IOrderObject[],
              // public transactions?: ITransaction[],
              // public customerFiles?: ICustomerFile[],
              public users?: any,
              public usersId?: any,
              public usersList?: any[],
              // public projects?: IProject[]
  ) {
    this.country = 'ايران';
  }
}
